<div class="item" [attr.data-range-state]="rangeState()">
  <p
    class="text rounded-full transition-colors"
    [attr.data-text]="textColor()"
    [attr.data-background]="backgroundColor()">
    {{ day().format('DD') }}
  </p>
</div>
